import Loading from "../../../assets/svg/loading.svg";

export const ResetPassword = ({ signInData, setSignInData, isValidEmail, setStep }) => (
  <>
    <div className="flex-col align-items-center justify-content-center">
      <div className="font-32 bold text-black p-tb-32">Reset your password</div>
    </div>
    <div className="auth-form auth-login">
      <div className="auth-row">
        {/* email */}
        <div className="auth-row p-b-16">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            placeholder="email"
            id="email"
            className={`w-100p ${!signInData.email && "error"}`}
            value={signInData.email}
            onChange={(e) => setSignInData((p) => ({ ...p, email: e.target.value }))}
          />
          {signInData.email.length === 0 && <span className="auth-input-error">This field can't be empty-item</span>}
          {signInData.email.length > 0 && (
            <span className={`auth-input-error ${isValidEmail(signInData.email) && "visibility-hidden"}`}>Format is invalid</span>
          )}
        </div>
      </div>
      <div className="auth-row p-tb-24">
        <div
          className={`btn-full 
                    ${!signInData.email || !isValidEmail(signInData.email) || (signInData.waiting && "disable")}`}
          onClick={() => setStep("email-verification")}>
          {signInData.waiting ? <img src={Loading} alt="" /> : <span className="p-lr-8">Send password reset link</span>}
        </div>
      </div>

      <div className="auth-row">
        <div className="justify-content-center">
          <span onClick={() => setStep("login")} className="pointer">
            Back to log in
          </span>
        </div>
      </div>
    </div>
  </>
);
